import { BadgeSelector } from './BadgeSelector';

export default BadgeSelector;